import type { Audit, GuardianType } from "@/services/api/guardiansv2/types";

const PERSONAS: GuardianType[] = ["ace", "ivy", "nova"];

/** Whether a persona participated in this audit (ran or completed). */
export function guardianRanForAudit(audit: Audit, persona: GuardianType): boolean {
  return (
    Boolean(audit.personas[persona]) || audit.personas_completed.includes(persona)
  );
}

/** Personas at/after ``persona`` in execution order (for cascade rerun). */
export function personasFrom(persona: GuardianType): GuardianType[] {
  const index = PERSONAS.indexOf(persona);
  return index >= 0 ? PERSONAS.slice(index) : [];
}
